import { Endpoints, makeAuthDeleteRequest, makeAuthGetRequest } from "../../network/http-client";
export class OperationsService {
    operationsStore;
    logStore;
    PAGE_SIZE = 50; // default size of entries per API request
    constructor(operationsStore, logStore) {
        this.operationsStore = operationsStore;
        this.logStore = logStore;
    }
    // This method starts loading from page 0 and sets the operations instead of appending
    async getOperationsList(userId, regId, logOnSuccess = false) {
        const pageNumber = 0;
        const operations = await this.fetchOperations(userId, regId, pageNumber, this.PAGE_SIZE);
        const allEntriesLoaded = operations.length < this.PAGE_SIZE;
        this.operationsStore.setOperations(operations, allEntriesLoaded, regId);
        if (logOnSuccess) {
            this.logStore.logSuccess("Operations reloaded successfully.", "operations.reloadedOk");
        }
        return operations;
    }
    // Paginating load
    async getNextPage(userId) {
        try {
            const pageNumber = this.operationsStore.pageNumber + 1;
            // use registration id from store
            const regId = this.operationsStore.registrationId;
            const operations = await this.fetchOperations(userId, regId, pageNumber, this.PAGE_SIZE);
            const allEntriesLoaded = operations.length < this.PAGE_SIZE;
            this.operationsStore.appendOperations(operations, allEntriesLoaded, pageNumber);
        }
        catch (error) {
            console.error(error);
        }
    }
    async cancelOperation(op, reason) {
        const result = await this.deleteOperation(op, reason);
        if (result.status === "OK") {
            this.logStore.logSuccess("Operation cancelled successfully.", "operations.detail.cancelledOk");
        }
    }
    async reloadOperation(opId, logOnSuccess = false) {
        const operation = await this.fetchOperation(opId);
        // if there was no previously selected operation, or if the reloaded is the same as selected
        if ((this.operationsStore.selectedOperation === null)
            || (operation.operationId === this.operationsStore.selectedOperation?.operationId)) {
            this.operationsStore.setSelectedOperation(operation);
        }
        if (logOnSuccess) {
            this.logStore.logSuccess("Operation reloaded successfully.", "operations.detail.reloadedOk");
        }
    }
    async reloadOperationsList(userId) {
        await this.getOperationsList(userId, this.operationsStore.registrationId);
    }
    // PRIVATE - only service private methods can use API types directly. Log error and reject promises on unhappy path.
    async fetchOperations(userId, regId, pageNumber, pageSize) {
        // TODO: make sure userId is sanitized
        const params = {
            userId,
            ...(regId ? { registrationId: regId } : {}),
            pageNumber: pageNumber.toString(),
            pageSize: pageSize.toString(),
        };
        const res = await makeAuthGetRequest(Endpoints.operations, params);
        if (res.response) {
            return res.response.operations;
        }
        // Error otherwise
        this.logStore.logResponseError(res, this.fetchOperations.name);
        return Promise.reject(new Error("Fetching operations failed. For more see Error Logs."));
    }
    async fetchOperation(opId) {
        const res = await makeAuthGetRequest(`${Endpoints.operations}/${opId}`, {});
        if (res.response) {
            return res.response;
        }
        // error path
        this.logStore.logResponseError(res, this.fetchOperation.name);
        return Promise.reject(new Error("Fetch operation failed. For more see Error Logs."));
    }
    async deleteOperation(op, reason) {
        const res = await makeAuthDeleteRequest(`${Endpoints.operations}/${op.operationId}`, { statusReason: reason });
        if (res.response) {
            return res.response;
        }
        // Error otherwise
        this.logStore.logResponseError(res, this.deleteOperation.name);
        return Promise.reject(new Error("Delete operation failed. For more see Error Logs."));
    }
}
